import AddIcon from '@mui/icons-material/Add';
import { useLocation } from 'react-router-dom';
import HeaderLinks from '@/components/general/HeaderLinks';
import { ValuesWithLabel } from '@/types';
import * as Styles from './ListHeader.styles';
import { getHeaderLinks } from './ListHeader.utils';
import CandidateSort, { CandidateSortType } from '../CandidateSort';
import PageSmallTitle from '../PageSmallTitle/PageSmallTitle.component';

export type ListHeaderProps = Partial<CandidateSortType> & {
  onShowFiltersHandler?: () => void;
  onShowCandidateFormClick?: (event: any) => void;
  showActionsArea?: boolean;
  showSearchBar?: boolean;
  isCandidatesSearchBar?: boolean;
  showLinks?: boolean;
  title?: string;
  className?: string;
  sortByOptions?: ValuesWithLabel[];
};

const ListHeader = ({
  onShowFiltersHandler,
  onUpdateSortBy,
  column,
  order,
  onShowCandidateFormClick,
  showActionsArea = true,
  showSearchBar = true,
  isCandidatesSearchBar = true,
  showLinks = true,
  title = 'Candidates',
  className,
  sortByOptions,
}: ListHeaderProps): JSX.Element => {
  const location = useLocation();

  const headerLinks = getHeaderLinks(location.pathname);

  return (
    <Styles.Header className={className}>
      <PageSmallTitle data-testid="candidates-list-header-title" title={title} />
      {showLinks && <HeaderLinks links={headerLinks} />}

      <Styles.HeaderRightSide className="flex align-center">
        {showActionsArea && (
          <Styles.ActionsArea>
            {onShowFiltersHandler && (
              <Styles.AddFilters onClick={onShowFiltersHandler} type="button">
                Filter
              </Styles.AddFilters>
            )}

            {column && order && onUpdateSortBy && (
              <CandidateSort
                order={order}
                column={column}
                onUpdateSortBy={onUpdateSortBy}
                sortByOptions={sortByOptions}
              />
            )}

            {showSearchBar &&
              (isCandidatesSearchBar ? <Styles.SearchInput /> : <Styles.JobSearchInput />)}

            {onShowCandidateFormClick && (
              <Styles.AddNew
                data-testid="add-new-candidate-btn"
                aria-label="New Candidate"
                onClick={onShowCandidateFormClick}
              >
                <AddIcon />
              </Styles.AddNew>
            )}
          </Styles.ActionsArea>
        )}
      </Styles.HeaderRightSide>
    </Styles.Header>
  );
};

export default ListHeader;
